import React from 'react';
import { Drawer, FormUser } from '../../components';
import { useStyles } from '../../services/material-ui';

import RowHeaderHelp from '../../components/RowHeaderHelp';

const EditUser: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <RowHeaderHelp name="Editar Usuário" />
        <FormUser />
      </main>
    </div>
  );
};

export default EditUser;
